import Table from './Table';
export * from './interface';
export default Table;
